import { ContactClose } from "../components/sections/ContactClose";
import { ConnectedStory } from "../components/sections/ConnectedStory";
import {
  EverydaySection,
  LandingFaq,
  StartupBand,
} from "../components/sections/EverydaySections";
import { Hero } from "../components/sections/Hero";

export default function HomePage() {
  return (
    <main className="landing">
      <Hero />
      <StartupBand />
      <ConnectedStory />
      <EverydaySection />
      <LandingFaq />
      <ContactClose />
    </main>
  );
}
